import React from "react";

import imageOne from "../../assets/image/inner-page/png/app.png";
import imageTwo from "../../assets/image/inner-page/png/small-card.png";
import imageThree from "../../assets/image/inner-page/png/big-green-circle-img.png";

import iconApple from "../../assets/image/inner-page/png/apple-button.png";
import iconGoogle from "../../assets/image/inner-page/png/google-play-button.png";

const ContentTwo = ({ className, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-xl-6 col-lg-6 col-xs-9"
            data-aos="fade-right"
            data-aos-delay={500}
          >
            <div className="l3-content-image-5 mt-5 mt-lg-0">
              <div className="img-1">
                <img className="w-100" src={imageOne} alt="" />
              </div>
              <div className="img-2">
                <img className="w-100" src={imageTwo} alt="" />
              </div>
              <div className="img-3">
                <img className="w-100" src={imageThree} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-5 col-lg-6 col-md-7 col-xs-10"
            data-aos="fade-left"
            data-aos-delay={500}
          >
            <div className="pl-lg-15 pt-11 pt-lg-0">
              <h2 className="font-size-10 mb-8">
                Ficha cuando quieras, donde sea
              </h2>
              <p className="font-size-6 mb-0">
                Con la app nativa tus empleados/as tienen la herramienta para
                fichar en el bolsillo. También pueden consultar su situación en
                la empresa, realizar solicitudes de ausencias, vacaciones,
                permutas e incluso de equipamiento.
              </p>
              <div className="mt-9">
                <a
                  className="d-block mb-6"
                  href="https://apps.apple.com/es/app/timeview/id1530163072"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconApple} alt="" />
                </a>
                <a
                  className="d-block mb-6"
                  href="https://play.google.com/store/apps/details?id=com.timeview"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iconGoogle} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentTwo;
